import { Box, styled } from "@mui/material";

import { BorderRadiusVariants } from "fond/theme";

export const SummaryContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1, 1.5, 1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(0.5),
}));

export const SummaryHeader = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  marginBottom: theme.spacing(1),
}));

export const SummaryTitle = styled(Box)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 700,
}));

export const SummaryTiles = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
}));

export const SummaryTile = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: BorderRadiusVariants.small,
  flex: 1,
  padding: theme.spacing(0.75, 1),
}));

export const TileCaption = styled(Box)(({ theme }) => ({
  alignItems: "center",
  color: theme.palette.text.secondary,
  display: "flex",
  fontSize: theme.typography.size.small,
  gap: theme.spacing(0.5),
  textTransform: "uppercase",
  "& svg": {
    fontSize: theme.typography.size.small,
  },
}));

export const TileValue = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  fontSize: 14,
  fontWeight: 600,
}));

export const CategoryCounter = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "inline-flex",
  gap: theme.spacing(0.5),
  "& svg": {
    color: theme.palette.text.secondary,
    width: 14,
    height: 14,
  },
}));
